var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntertainment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Entertainment") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9,1.5 C13.1421356,1.5 16.5,4.85786438 16.5,9 C16.5,13.1421356 13.1421356,16.5 9,16.5 C4.85786438,16.5 1.5,13.1421356 1.5,9 C1.50468426,4.85980621 4.85980621,1.50468426 9,1.5 L9,1.5 Z M9,0.25 C4.16750844,0.25 0.25,4.16750844 0.25,9 C0.25,13.8324916 4.16750844,17.75 9,17.75 C13.8324916,17.75 17.75,13.8324916 17.75,9 C17.75,6.67935571 16.8281276,4.45375898 15.1871843,2.81281566 C13.546241,1.17187235 11.3206443,0.25 9,0.25 Z M6.8125,13.162 C6.29508832,13.1605565 5.87609872,12.7412875 5.875,12.223875 L5.875,5.776125 C5.87509515,5.445292 6.04955357,5.13900188 6.33406219,4.97016667 C6.61857081,4.80133146 6.97100329,4.79495008 7.2614375,4.953375 L7.2614375,4.953375 L13.1715,8.17725 C13.4723987,8.34161749 13.6595685,8.65713459 13.6595685,9 C13.6595685,9.34286541 13.4723987,9.65838251 13.1715,9.82275 L7.2614375,13.046625 C7.1237794,13.1219824 6.96943425,13.1616484 6.8125,13.162 L6.8125,13.162 Z M7.125,6.302875 L7.125,11.6971875 L12.0694375,9 L7.125,6.302875 Z M6.6625,6.0508125 L6.664,6.0514375 L6.6625,6.0508125 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icon-color",
    fill: "#194A74",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntertainment);
export default __webpack_public_path__ + "static/media/Entertainment.1a1f3470.svg";
export { ForwardRef as ReactComponent };